import React from "react";
import { FaGlobe, FaGithub } from "react-icons/fa";

const ProjectsCard = ({ title, des, src, githubLink, websiteLink }) => {
  return (
    <a href={websiteLink} target="_blank">
      <div
        className="w-full h-auto rounded-xl p-5 cursor-pointer
     shadow-shadowOne flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-gray-900 hover:gray-900 transition-colors duration-1000"
      >
        <div className="w-full overflow-hidden">
          <img
            className="w-fullh-60"
            style={{ height: 50, objectFit: "cover" }}
            src={src}
            alt={title}
          />
        </div>
        <div className="w-full mt-5 flex flex-col gap-6">
          <div>
            <div>
              <h3 className="font-titleFont font-bold uppercase text-designColor">
                {title}
              </h3>
            </div>
            <p
              className="text-sm font-bodyFont tracking-wide my-3 hover:text-gray-100 duration-300 text-justify"
              style={{ display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" }}
            >
              {des}
            </p>
            <div className="flex gap-2">
              {/* <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
              <a href={githubLink} target="_blank" rel="noopener noreferrer">
                <FaGithub />
              </a>
            </span> */}
              <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300">
                <a href={websiteLink} target="_blank" rel="noopener noreferrer">
                  <FaGlobe />
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default ProjectsCard;
